import React, { createContext, useContext, useState } from 'react';

// Create a context for search settings
const SearchSettingsContext = createContext(null);

// Default search settings
const defaultSettings = {
  search_system: 'shopify',
  settings: {},
  initialized: false
};

// Create a single shared state to ensure settings are available globally
let globalSearchSettings = { ...defaultSettings };

/**
 * Provider component for search settings
 * This makes search settings available to any component in the application
 */
export function SearchSettingsProvider({ children }) {
  const [searchSettings, setSearchSettings] = useState(globalSearchSettings);

  // Update the search settings
  const updateSearchSettings = (newSettings) => {
    // Only update if not already initialized or if overrideInitialized is true
    if (!searchSettings.initialized || newSettings.overrideInitialized) {
      // console.log('Updating global search settings', newSettings);
      const updatedSettings = {
        ...searchSettings,
        ...newSettings,
        initialized: true
      };
      globalSearchSettings = updatedSettings; // Update the global reference
      setSearchSettings(updatedSettings);
    } else {
      // console.log('Search settings already initialized, not updating');
    }
  };

  return (
    <SearchSettingsContext.Provider value={{ 
      searchSettings, 
      updateSearchSettings,
      initialized: searchSettings.initialized
    }}>
      {children}
    </SearchSettingsContext.Provider>
  );
}

/**
 * Hook to access the search settings context
 */
export function useSearchSettings() {
  const context = useContext(SearchSettingsContext);
  if (!context) {
    throw new Error('useSearchSettings must be used within a SearchSettingsProvider');
  }
  return context;
}